
import Vue from 'vue';
import { Component, Emit, Prop } from 'vue-property-decorator';

@Component({ name: 'FilterBarContentTypeItem' })
export default class FilterBarContentTypeItem extends Vue {
	@Prop({ required: true }) label: string;
	@Prop({ required: true }) active: boolean;
	@Prop({ default: null }) url: string;

	@Emit('click')
	click(active: boolean) {
		return active;
	}
}
